<template>
  <div class="Box">
    <b-loading
      v-if="isLoading"
      :is-full-page="false"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <div class="columns has-text-left important-message">
      <div class="column is-narrow">
        <b-button
          rounded
          type="is-zero"
          style="padding: 1.2rem; cursor: default;"
        >
          <b-icon
            icon="microphone-alt"
            type="is-fff"
            style="position: relative; top: 2px;"
          ></b-icon>

          <b class="has-text-fff" style="position: relative; bottom: 4px;">
            IMPORTANTE
          </b>
        </b-button>
      </div>

      <div class="column has-text-zero">
        Os 2 representantes poderão solicitar Ações de Desenvolvimento em nome
        da OE e poderão ser trocados a qualquer momento.
      </div>
    </div>

    <h2 class="has-text-weight-bold">
      Representante 1 (você)
    </h2>
    <br />

    <div class="columns">
      <div class="column">
        <!-- OE - Lider 1: email -->
        <b-field
          :label="$parent.$parent.$parent.oe.leader1.email ? 'E-mail' : ''"
          label-position="on-border"
        >
          <b-input
            v-model="$parent.$parent.$parent.oe.leader1.email"
            disabled
          ></b-input>
        </b-field>
      </div>

      <div class="column">
        <!-- OE - Lider 1: nome -->
        <b-field
          :label="$parent.$parent.$parent.oe.leader1.name ? 'Nome' : ''"
          label-position="on-border"
        >
          <b-input
            v-model="$parent.$parent.$parent.oe.leader1.name"
            disabled
          ></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <!-- OE - Lider 1: curso -->
        <b-field
          :label="$parent.$parent.$parent.oe.leader1.course ? 'Curso' : ''"
          label-position="on-border"
        >
          <b-input
            v-model="$parent.$parent.$parent.oe.leader1.course"
            disabled
          ></b-input>
        </b-field>
      </div>

      <div class="column">
        <!-- OE - Lider 1: posicao -->
        <b-field
          :label="
            $parent.$parent.$parent.oe.leader1.position ? 'Posição na OE' : ''
          "
          label-position="on-border"
        >
          <b-input
            v-model="$parent.$parent.$parent.oe.leader1.position"
            placeholder="Sua Posição na OE"
          ></b-input>
        </b-field>
      </div>

      <div class="column">
        <!-- OE - Lider 1: telefone -->
        <b-field
          :label="
            $parent.$parent.$parent.oe.leader1.areacode ? 'DDD + Celular' : ''
          "
          label-position="on-border"
        >
          <b-select
            v-model="$parent.$parent.$parent.oe.leader1.areacode"
            id="leader1areacode"
          >
            <option value="">DDD</option>
          </b-select>

          <b-input
            v-model="leader1cellphone"
            placeholder="Seu Celular"
            type="tel"
            expanded
            @input.native="formatCellphoneWithoutAreacode('leader1cellphone')"
          ></b-input>
        </b-field>
      </div>
    </div>

    <h2 class="has-text-weight-bold">
      Representante 2
    </h2>
    <br />

    <div class="columns">
      <div class="column">
        <!-- OE - Lider 2: email -->
        <b-field
          :label="$parent.$parent.$parent.oe.leader2.email ? 'E-mail' : ''"
          label-position="on-border"
        >
          <b-input
            v-model="$parent.$parent.$parent.oe.leader2.email"
            placeholder="E-mail pessoal"
            @blur="checkStudentEmail"
          ></b-input>
        </b-field>
      </div>

      <div class="column">
        <!-- OE - Lider 2: nome -->
        <b-field
          :label="$parent.$parent.$parent.oe.leader2.name ? 'Nome' : ''"
          label-position="on-border"
          :style="hasCheckedLeader2email ? 'display: block' : 'display: none'"
        >
          <b-input
            v-model="$parent.$parent.$parent.oe.leader2.name"
            placeholder="Nome completo"
          ></b-input>
        </b-field>
      </div>
    </div>

    <div
      class="columns"
      :style="hasCheckedLeader2email ? 'display: block' : 'display: none'"
    >
      <div class="column">
        <!-- OE - Lider 2: curso -->
        <course
          @update-course="updateCourse"
          name="leader2"
          ref="leader2course"
        />
      </div>

      <div class="column">
        <!-- OE - Lider 2: posicao -->
        <b-field
          :label="
            $parent.$parent.$parent.oe.leader2.position ? 'Posição na OE' : ''
          "
          label-position="on-border"
        >
          <b-input
            v-model="$parent.$parent.$parent.oe.leader2.position"
            placeholder="Posição na OE"
          ></b-input>
        </b-field>
      </div>

      <div class="column">
        <!-- OE - Lider 2: telefone -->
        <b-field
          :label="
            $parent.$parent.$parent.oe.leader2.areacode ? 'DDD + Celular' : ''
          "
          label-position="on-border"
        >
          <b-select
            v-model="$parent.$parent.$parent.oe.leader2.areacode"
            id="leader2areacode"
          >
            <option value="">DDD</option>
          </b-select>
          <b-input
            v-model="leader2cellphone"
            placeholder="Celular"
            type="tel"
            expanded
            @input.native="formatCellphoneWithoutAreacode('leader2cellphone')"
          ></b-input>
        </b-field>
      </div>
    </div>

    <h2 class="has-text-weight-bold">
      Informe, pelo menos, mais dois integrantes da OE
    </h2>
    <br />

    <div
      v-for="(contact, index) in $parent.$parent.$parent.oe.otherContacts"
      :key="`contact-${index}`"
      style="margin-bottom: 1rem"
    >
      <oe-contact
        :contact="contact"
        :index="index"
        @add-contact="addContact"
        @remove-contact="removeContact"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { ddds } from "../../../assets/js/ddds";
import { commom } from "../../../mixins/commom";
import { mask } from "../../../mixins/mask";
import oeContact from "../OEContact";
import course from "../Course";

export default {
  mixins: [commom, mask],

  components: {
    oeContact,
    course
  },

  data() {
    return {
      isLoading: false,
      leader1cellphone: "",
      leader2cellphone: "",
      hasCheckedLeader2email: false
    };
  },

  methods: {
    addContact() {
      this.$parent.$parent.$parent.oe.otherContacts.push({
        name: "",
        email: ""
      });
    },

    removeContact(index) {
      if (this.$parent.$parent.$parent.oe.otherContacts.length > 2) {
        this.$parent.$parent.$parent.oe.otherContacts.splice(index, 1);
      }
    },

    updateCourse(course, leader) {
      this.$parent.$parent.$parent.oe[leader].course = course;
    },

    checkStudentEmail() {
      this.isLoading = true;
      this.$store
        .dispatch("checkStudentEmail", {
          email: this.$parent.$parent.$parent.oe.leader2.email
        })
        .then(res => {
          if (res.data.result === "ok") {
            this.$parent.$parent.$parent.oe.leader2.name = `
              ${res.data.payload.name} ${res.data.payload.surname}`;
            this.$parent.$parent.$parent.oe.leader2.course =
              res.data.payload.course;
            this.$refs.leader2course.localCourse = res.data.payload.course;
          } else {
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
          this.hasCheckedLeader2email = true;
        });
    }
  },

  computed: {
    ...mapGetters(["account"])
  },

  watch: {
    leader1cellphone(value) {
      this.$parent.$parent.$parent.oe.leader1.cellphone = value;
    },
    leader2cellphone(value) {
      this.$parent.$parent.$parent.oe.leader2.cellphone = value;
    }
  },

  mounted() {
    this.isLoading = false;
    this.$parent.$parent.$parent.oe.leader1.name =
      this.account.name + " " + this.account.surname;
    this.$parent.$parent.$parent.oe.leader1.email = this.account.email;
    this.$parent.$parent.$parent.oe.leader1.course = this.account.course;

    let dddsOptions = "";
    const dddslen = ddds.length;
    for (let i = 0; i < dddslen; i++)
      dddsOptions += `<option value="${ddds[i]}">${ddds[i]}</option>`;
    document.getElementById("leader1areacode").innerHTML += dddsOptions;
    document.getElementById("leader2areacode").innerHTML += dddsOptions;
  }
};
</script>

<style scoped>
.Box {
  max-width: 800px !important;
  margin: auto;
}
.important-message {
  margin: -1rem;
}
</style>
